import {React} from 'react';
import { CaseForms } from '../../../Constantes/caseForms';

export default function Form (props) {

    const {classes,template,dataForm,setDataForm, setNames} = props;

    return (
        <form style={{rowGap: "1rem"}}>
            <CaseForms setDataForm={setDataForm} setNames={setNames} dataForm={dataForm} classes={classes} template={template}></CaseForms>
        </form>
    );
};